export const state = () => ({
    hadiths: [],
});
